(() => {
  const initMobileCart = () => {
    const sticky = document.querySelector('[data-gr-mobile-cart]');
    if (!sticky) return;
    if (sticky.dataset.initialized === 'true') return;
    sticky.dataset.initialized = 'true';

    if (sticky.hasAttribute('data-visibility-aware')) {
      const productInfo = sticky.closest('product-info');
      const mainInfo = productInfo?.querySelector('[id^="ProductInfo-"]');
      const form = productInfo?.querySelector('product-form form[action*="/cart/add"]');
      const mainButton = form?.querySelector('[name="add"]');
      const button = sticky.querySelector('[data-gr-mobile-add]');
      const price = sticky.querySelector('[data-gr-mobile-price]');
      if (!form || !mainButton || !mainInfo || !button) return;
      const mobile = matchMedia('(max-width: 749px)');
      const purchaseControls = mainButton.closest('.product-form__buttons') || mainButton;
      let controlsVisible = true;
      const updateVisibility = () => {
        const modalOpen = !!document.querySelector('cart-drawer.active, dialog[open], product-modal[open], modal-dialog[open], .gr-search-overlay.is-open');
        sticky.hidden = !mobile.matches || controlsVisible || modalOpen;
      };
      const sync = () => {
        const currentButton = form.querySelector('[name="add"]');
        if (!currentButton) return;
        button.disabled = currentButton.disabled || currentButton.getAttribute('aria-disabled') === 'true';
        button.textContent = currentButton.querySelector('span')?.textContent.trim() || currentButton.textContent.trim();
        button.setAttribute('aria-busy', String(currentButton.classList.contains('loading')));
        const currentPrice = [...mainInfo.querySelectorAll('[id^="price-"] .price-item')].find(item => item.getClientRects().length && !item.closest('s'));
        if (price && currentPrice) price.textContent = currentPrice.textContent.trim();
        updateVisibility();
      };
      button.addEventListener('click', () => { if (!button.disabled) mainButton.click(); });
      const intersection = new IntersectionObserver(entries => { controlsVisible = entries[0].isIntersecting; updateVisibility(); }, { threshold: 0 });
      intersection.observe(purchaseControls);
      const observer = new MutationObserver(sync);
      observer.observe(mainInfo, { subtree: true, childList: true, attributes: true, characterData: true });
      const overlayObserver = new MutationObserver(updateVisibility);
      overlayObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      document.querySelectorAll('cart-drawer, dialog, product-modal, modal-dialog').forEach(dialog => overlayObserver.observe(dialog, { attributes: true, attributeFilter: ['class', 'open'] }));
      mobile.addEventListener('change', updateVisibility);
      document.addEventListener('shopify:section:unload', event => {
        if (!event.target.contains(sticky)) return;
        intersection.disconnect(); observer.disconnect(); overlayObserver.disconnect();
        mobile.removeEventListener('change', updateVisibility);
      }, { once: true });
      sync();
      return;
    }

    const stickyButton = sticky.querySelector('[data-gr-mobile-add]');
    const stickyPrice = sticky.querySelector('[data-gr-mobile-price]');
    const getProductForm = () => document.querySelector('product-form form[action*="/cart/add"]');
    const getMainButton = () => getProductForm()?.querySelector('[name="add"]');

    const sync = () => {
      const mainButton = getMainButton();
      if (!mainButton || !stickyButton) return;
      stickyButton.disabled = mainButton.disabled;
      const mainText = mainButton.querySelector('span')?.textContent.trim() || mainButton.textContent.trim();
      stickyButton.textContent = mainButton.disabled ? mainText : 'Add to cart';
      const price = document.querySelector('[id^="price-"] .price-item--sale') || document.querySelector('[id^="price-"] .price-item--regular');
      if (price && stickyPrice) stickyPrice.textContent = price.textContent.trim();
    };

    stickyButton?.addEventListener('click', () => {
      const mainButton = getMainButton();
      if (mainButton && !mainButton.disabled) mainButton.click();
    });

    new MutationObserver(sync).observe(document.querySelector('[id^="ProductInfo-"]') || document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      characterData: true,
    });
    sync();
  };

  const initTabs = () => {
    document.querySelectorAll('[data-gr-product-tabs]').forEach((root) => {
      const tabs = [...root.querySelectorAll('[data-gr-tab]')];
      const panels = [...root.querySelectorAll('[data-gr-panel]')];
      if (!tabs.length) return;

      const activate = (tab) => {
        tabs.forEach((item) => item.setAttribute('aria-selected', String(item === tab)));
        panels.forEach((panel) => { panel.hidden = panel.dataset.grPanel !== tab.dataset.grTab; });
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let nextIndex = index;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          tabs[nextIndex].focus();
          activate(tabs[nextIndex]);
        });
      });
      activate(tabs[0]);
    });
  };

  const initRecentlyViewed = () => {
    const storageKey = 'gr-recent-product-handles';
    document.querySelectorAll('[data-gr-recent-products]').forEach(async (root) => {
      const current = root.dataset.currentHandle;
      const limit = Number(root.dataset.productCount || 4);
      let handles = [];
      try { handles = JSON.parse(localStorage.getItem(storageKey) || '[]'); } catch (_error) { handles = []; }
      handles = handles.filter((handle) => handle && handle !== current).slice(0, limit);
      const grid = root.querySelector('[data-gr-recent-grid]');
      root.querySelector('[data-gr-recent-prev]')?.addEventListener('click', () => grid?.scrollBy({ left: -grid.clientWidth * 0.8, behavior: 'smooth' }));
      root.querySelector('[data-gr-recent-next]')?.addEventListener('click', () => grid?.scrollBy({ left: grid.clientWidth * 0.8, behavior: 'smooth' }));

      if (grid && handles.length) {
        const products = await Promise.all(handles.map(async (handle) => {
          try {
            const response = await fetch(`${window.Shopify?.routes?.root || '/'}products/${encodeURIComponent(handle)}.js`);
            return response.ok ? response.json() : null;
          } catch (_error) { return null; }
        }));
        const currency = root.dataset.moneyCurrency || 'USD';
        const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency });
        products.filter(Boolean).forEach((item) => {
          const card = document.createElement('article');
          card.className = 'gr-product-recent-card';
          const link = document.createElement('a');
          link.className = 'gr-product-recent-card__media';
          link.href = item.url;
          if (item.featured_image) {
            const image = document.createElement('img');
            image.src = item.featured_image;
            image.alt = item.title;
            image.loading = 'lazy';
            link.append(image);
          }
          const content = document.createElement('div');
          content.className = 'gr-product-recent-card__content';
          const title = document.createElement('h3');
          const titleLink = document.createElement('a');
          titleLink.href = item.url;
          titleLink.textContent = item.title;
          title.append(titleLink);
          const price = document.createElement('strong');
          price.textContent = money.format(item.price / 100);
          content.append(title, price);
          card.append(link, content);
          grid.append(card);
        });
      }

      const updated = [current, ...handles].filter(Boolean).slice(0, 12);
      try { localStorage.setItem(storageKey, JSON.stringify(updated)); } catch (_error) { /* Storage can be unavailable. */ }
      if (grid && !grid.children.length) root.hidden = true;
    });
  };

  const init = () => {
    initMobileCart();
    initTabs();
    initRecentlyViewed();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
